export default __webpack_public_path__ + "static/media/sliderFlip_noThemeSelected.504251ca.svg";